export const MemberTestingProgrammeCn = {
    xunjiadang:'检测方案与列表',
    kaishishijian:'开始时间',
    jieshushijian:'结束时间',
    shushuru:'请输入方案名称或编号',
    sousuo:'搜索',
    quanxuan:'全选',
    shanshu:'删除',
    fanyangmingcheng:'方案名称',
    cangkaozongjiage:'参考总价格',
    shuliang:'数量',
    caozuo:'操作'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/MemberTestingProgramme/MemberTestingProgrammeCn.js